import { type FormSelectBlock as FormSelectBlockT } from "@/payload-types";
import { type FormElement as FormVariantT } from "@/payload-types";
import Combobox from "@/components/frontend/ui/form/inputs/combobox";
import type { ComboboxOption } from "@/components/frontend/ui/form/inputs/combobox";

type FormSelectBlockProps = FormSelectBlockT & {
	containerClassName?: string;
	variant?: FormVariantT | "default" | number | null | undefined;
	fieldName?: string;
	fieldValue?: unknown;
	fieldError?: string;
	onFieldChange?: (value: unknown) => void;
	onFieldBlur?: () => void;
};

export const FormSelectBlock: React.FC<FormSelectBlockProps> = ({
	content,
	options,
	settings,
	variant,
	containerClassName,
	fieldName,
	fieldValue,
	fieldError,
	onFieldChange,
	onFieldBlur,
}) => {
	const mappedOptions = options?.map((option) => ({ label: option.label, value: option.value })) ?? [];
	const multiple = settings?.multiple ?? false;

	return (
		<Combobox
			name={fieldName}
			formVariant={variant}
			multiple={multiple}
			search={settings?.searchable ?? true}
			value={multiple ? (Array.isArray(fieldValue) ? (fieldValue as ComboboxOption[]) : []) : ((fieldValue as ComboboxOption | null | undefined) ?? null)}
			onValueChange={(value) => onFieldChange?.(value)}
			onBlur={onFieldBlur}
			label={content.label}
			hideLabel={settings?.hideLabel ?? undefined}
			description={content.description}
			error={fieldError}
			placeholder={content.placeholder ?? undefined}
			required={content.required ?? false}
			options={mappedOptions}
			containerClassName={containerClassName}
		/>
	);
};
